import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute} from '@angular/router';
import {AppsettingsService} from '../../../services/appsettings.service';
import Swiper from 'swiper';

@Component({
  selector: 'app-toll-plaza-and-fees',
  templateUrl: './toll-plaza-and-fees.component.html',
  styleUrls: ['./toll-plaza-and-fees.component.scss']
})

export class TollplazaAndfeesComponent implements OnInit {

  configUrl: any;
  authToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1laWQiOiIwNkZCREI5Ny1DRjA0LTQ5OEQtQjVFQS0yMUY0NUMwQkRCM0UiLCJ1bmlxdWVfbmFtZSI6Impmb3VyaWVAb3V0bG9vay5jb20iLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL2FjY2Vzc2NvbnRyb2xzZXJ2aWNlLzIwMTAvMDcvY2xhaW1zL2lkZW50aXR5cHJvdmlkZXIiOiJBU1AuTkVUIElkZW50aXR5IiwiQXNwTmV0LklkZW50aXR5LlNlY3VyaXR5U3RhbXAiOiI2NzUzMThjOC0wNDRmLTRlN2EtYTg1OC0zYWExMzJhNGZiMmUiLCJDaGFuZ2VQYXNzd29yZCI6IkZhbHNlIiwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo1NTI3IiwiYXVkIjoiODVFMTU4MEExNjhFNEY4OEJDMUZFQzA4RDIwMTJGQzUiLCJleHAiOjE2NTk0NTQxODAsIm5iZiI6MTYyNzkxODE4MH0.bFBthApAF_HofRR4Z6WVVzBDfdDBwryqM3VnbBR2LaU';

  public apiContent: any = '';
  public closeResult = '';
  public tollSelectedContent: any = '';
  public tollSelectedContentSingle: any = true;

  constructor(
    private http: HttpClient,
    private modalService: NgbModal,
    public appService: AppsettingsService
  ) {

  }

  ngOnInit(): void {
    this.appService.loadAppConfig().subscribe((response: any) => {
      this.configUrl = response.apiBaseUrl + '/TracService/api/v1/trac/getTollsData';
      this.getTollsData().subscribe(data => {
        this.apiContent = data;
        console.log(this.apiContent.body.Data);

        const swiper = new Swiper('.swiper', {
          // Default parameters
          slidesPerView: 1,
          spaceBetween: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          // Responsive breakpoints
          breakpoints: {
            // when window width is >= 320px
            480: {
              slidesPerView: 2,
              spaceBetween: 0,
              loop:true,
            },
            // when window width is >= 480px
            640: {
              slidesPerView: 3,
              spaceBetween: 5
            },
            // when window width is >= 1000px
            1000: {
              slidesPerView: 6,
              spaceBetween: 10
            }
          }
        })
      });
    });
  }

  getTollsData(): Observable<HttpResponse<any[]>> {
    const reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.authToken
    });

    return this.http.get<any[]>(this.configUrl, {observe: 'response', headers: reqHeader});
  }

  tollSelected(event: Event): void {
    this.tollSelectedContent = '';

    // document.querySelectorAll('.swiper .swiper-slide').forEach(el => el.remove())
    document.querySelectorAll('.swiper .swiper-slide .active').forEach(el => {
      el.classList.remove("active");
    })
    let elementId: string = (event.target as Element).id;
    let element = document.getElementById(elementId);
    element?.classList.add("active");
    console.log(elementId);
    if(elementId == "all"){
      this.tollSelectedContent = this.apiContent.body.Data;
      this.tollSelectedContentSingle = false;
    }else{
      this.tollSelectedContent = this.apiContent.body.Data[elementId] != '' ?this.apiContent.body.Data[elementId]:this.apiContent.body.Data[0];
      this.tollSelectedContentSingle = true;
    }
  }

  public open(content: any): void {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
